import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import Alert from 'react-s-alert';

import Map from '../Map';
import { ContentSplitter } from '../../components/ContentSplitter';
import { MainTable } from '../../components/MainTable';

import { handleLogout } from '../../actions/users';
import {
  setSingleElementID,
  unselectSelectedElement,
  handleElementDelete,
} from '../../actions/elements';

class Home extends Component {
  constructor(props) {
    super(props);
    this.onRowSelect = this.onRowSelect.bind(this);
  }

  componentDidUpdate() {
    const { error } = this.props;
    if (error) {
      Alert.error(error, {timeout: 2000});
    }
  }

  onRowSelect(state, rowInfo, column) {
    if (this.props.selectedElement && rowInfo.row.id === this.props.selectedElement.id) {
      this.props.unselectSelectedElement();

      return;
    }
    if (column.id !== 'select') {
      const { setSingleElementID } = this.props;
      setSingleElementID(rowInfo.row.id);
    }
  }

  render() {
    const {
      allElements,
      displayedElementProps,
      selectedElement,
      unselectSelectedElement,
      colorFilter,
      colorValues,
      handleElementDelete,
    } = this.props;

    if (!localStorage.getItem('token')) {
      return <Redirect to="/login" />;
    }

    return (
      <ContentSplitter>
        <Map />
        {allElements.length > 0 &&
          <MainTable
            colorFilter={colorFilter}
            colorValues={colorValues}
            deleteElement={handleElementDelete}
            elements={[...this.props.allElements]}
            handleRowSelect={this.onRowSelect}
            selected={displayedElementProps}
            selectedElementId={selectedElement ? selectedElement.id : null}
            unselectSelectedElement={unselectSelectedElement}
          />
        }
      </ContentSplitter>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users,
    allElements: state.elements.allElements,
    selectedElement: state.elements.selectedElement,
    displayedElementProps: state.elements.displayedElementProps,
    error: state.elements.error,
    colorFilter: state.elements.colorFilter,
    colorValues: state.elements.colorValues,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    handleLogout,
    setSingleElementID,
    unselectSelectedElement,
    handleElementDelete,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/content.js